module.exports = __webpack_public_path__ + "assets/img/sai_lp_s1_imows.08105891.png";